import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CommissionNote\CommissionNoteMailSentController::__invoke
* @see app/Http/Controllers/CommissionNote/CommissionNoteMailSentController.php
* @route '/api/commission-note/{commission_note}/mail-sent'
*/
const CommissionNoteMailSentController = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CommissionNoteMailSentController.url(args, options),
    method: 'post',
})

CommissionNoteMailSentController.definition = {
    methods: ["post"],
    url: '/api/commission-note/{commission_note}/mail-sent',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CommissionNote\CommissionNoteMailSentController::__invoke
* @see app/Http/Controllers/CommissionNote/CommissionNoteMailSentController.php
* @route '/api/commission-note/{commission_note}/mail-sent'
*/
CommissionNoteMailSentController.url = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { commission_note: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { commission_note: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            commission_note: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        commission_note: typeof args.commission_note === 'object'
        ? args.commission_note.id
        : args.commission_note,
    }

    return CommissionNoteMailSentController.definition.url
            .replace('{commission_note}', parsedArgs.commission_note.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CommissionNote\CommissionNoteMailSentController::__invoke
* @see app/Http/Controllers/CommissionNote/CommissionNoteMailSentController.php
* @route '/api/commission-note/{commission_note}/mail-sent'
*/
CommissionNoteMailSentController.post = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CommissionNoteMailSentController.url(args, options),
    method: 'post',
})

export default CommissionNoteMailSentController